import InsertCardsSection from './insert-cards-section'

export default InsertCardsSection
